import Switch from "antd/lib/switch";
import { useEffect, useState } from "react";
import styled from "styled-components";


// Internal Imports
import { COLORS } from "../../constants/colors";
import { useForm } from "../../../contexts/form";
import { IFormQuestion, IFormQuestionOption } from "../../../interfaces/IForm";
import IGroupKey from "../../../interfaces/IGroupKey";
import { getCopyOf, getError, openNotification, questionHasError, returnOrdenSelection, tryCatch } from "../../constants/Utilities";
import { PreguntaTipo } from "../../enums/AllEnums";
import EditTextForm from "../EditTextForm/EditTextForm";
import GroupColumn from "../GroupColumn/GroupColumn";
import GroupRow from "../GroupRow/GroupRow";
import MarginInput from "../MarginInput/MarginInput";
import Modal from "../Modal/Modal";
import SelectBox from "../SelectBox/SelectBox";
import { EditTextType, Mode } from "../../types/AllTypes";
import LoadingButton from "../LoadingButton/LoadingButton";
import useListFrecuenciaActulizacion from "../../../hooks/useListFrecuenciaActulizacion";
import { GetOptionsQuestionByQuery } from "../../../services/form";
import FloatingBottom from "../FloatingBottom/FloatingBottom";
import moment from "moment";

const Wrapper = styled.div`
    width: 90%;
    min-height: 200px;
    border-radius: 5px;
    background-color: ${COLORS.white_color2(1)};
    box-shadow: 0px 2px 1.5px ${COLORS.black_shadow_1};
    padding: 18px 13px 13px 13px;
    margin: 10px;
    position: relative;
    transition: .5s all;

    .footer {
        display: grid;
        grid-template-columns: 3fr repeat(6,auto);
        column-gap: 20px;
        position: absolute;
        border-top: 1px solid ${COLORS.black_text_color3};
        padding-top: 8px;
        bottom: 13px;
        right: 13px;
        left: 13px;
    }

    .separator {
        border: 0.5px solid ${COLORS.black_text_color3};
    }
    
    .textButton {
        color: ${COLORS.blue_main(1)};
        font-size: 1.1em;
        cursor: pointer;
        transition: .2s all;
    }

    .textButton:hover {
        opacity: 0.8;
    }

    .actions {
        color: ${COLORS.blue_main(1)};
        font-size: 1.2em;
        cursor: pointer;
        transition: .2s all;
    }

    .actions:hover{
        transform: scale(1.1);
    }

    .actions:active, .textButton:active{
        opacity: 0.7;
    }

    .required label{
        font-size: 1.1em;
        color: ${COLORS.black_text_color1};
        margin-right: 7px;
        font-weight: 300
    }

    .radioOption {
        border-bottom: 0.5px solid ${COLORS.black_text_color3};
        transition: .3s all;
        margin-top: 15px;
        padding-bottom: 5px;
    }

    .scrollOption {
       max-height: 160px;
       min-height: 50px;
       overflow-y: auto;
       overflow-x: hidden;
       margin-top: 5px;
    }


    .scrollOption::-webkit-scrollbar {
        background-color: var(--transparent_color1);
        width: 5px;
    }

    .scrollOption::-webkit-scrollbar-thumb {
        background-color: ${COLORS.black_text_color4};
        border-radius: 100px;
    }

    .radioOption .icon-radio {
        border: 0.5px solid ${COLORS.black_text_color3};
        border-radius: 50px;
        width: 35px;
        height: 35px;
    }

    .radioOption .icon-check {
        border: 0.5px solid ${COLORS.black_text_color3};
        border-radius: 5px;
        width: 35px;
        height: 35px;
    }

    .radioOption .icon-effect {
        color: ${COLORS.black_text_color3};
        opacity: 0.5;
        font-size: 1.2em;
        right: 13px;
        position: relative;
        cursor: pointer;
    }

    .radioOption .icon-effect:hover {
        color: ${COLORS.black_text_color3};
        opacity: 1;
    }

    .radioOption .icon-effect:active {
        opacity: 0.5;
    }

    .radioOption .selectOrden {
        position: relative;
        right:15px;
    }

    .optionContainer {
       width: 60%;
       position: relative;
       margin-bottom: 55px;
    }

    .wrapError {
        width: 45%;
        height: 100;
        margin: 15px 0px 5px 0px;
    }

     .wrapError label {
        margin-bottom: 15px;
     }

     .error-text {
        text-align: center;
        color: ${COLORS.red_error2};
        height: 20px;
     }

`;

interface Props {
    question: IFormQuestion;
    questionList: IFormQuestion[];
    onChange: (list: IFormQuestion[]) => void;
    index: number;
    typesQuestion: IGroupKey[];
    mode: Mode;
}

const TypeQuestionModel = ({ question, index, onChange, typesQuestion, questionList, mode }: Props) => {

    // States
    const { listFrecuency, loadingListFrecuency } = useListFrecuenciaActulizacion();
    const [modalAttrVisible, setModalAttrVisible] = useState<boolean>(false);
    const [modalQueryVisible, setModalQueryVisible] = useState<boolean>(false);
    const [loadingQuery, setLoadingQuery] = useState<boolean>(false);

    const [showRange, setShowRange] = useState<boolean>(mode === 'Add' ? false : true);
    const { formQuestion } = useForm();

    // Methods 
    const returnTypeRange = () => {
        let type: EditTextType = 'text';

        switch (question.preguntaTipoNombre) {
            case PreguntaTipo.Fecha:
                type = 'date';
                break;
            case PreguntaTipo.FechaHora:
                type = 'datetime-local';
                break;
            case PreguntaTipo.Hora:
                type = 'time';
                break;
            case PreguntaTipo.Numerico:
                type = 'number';
                break;
            case PreguntaTipo.FechaRango:
                type = 'date';
                break;
            case PreguntaTipo.FechaRangoMultiple:
                type = 'date';
                break;
        }

        return type;
    }

    const returnRangeLabel = (type: 'min' | 'max') => {
        let label = '';

        if (question.preguntaTipoNombre === PreguntaTipo.Numerico) {
            label = type === 'min' ? 'Mínimo' : 'Máximo';
        } else {
            label = type === 'min' ? 'Desde' : 'Hasta';
        }

        return label;
    }

    const showRemoveRange = () => {
        const internalList = questionList;
        internalList[index].valorMinimo = null;
        internalList[index].valorMaximo = null;
        setShowRange(!showRange);
        onChange([...internalList]);
    }

    const firstHasValueIfSecondHas = (value1: any, value2: any) => {
        return !!value2 && !value1 ? false : true;
    }

    const getIcon = () => {
        let iconLabel = 'fa-solid fa-question';

        if (!!question.preguntaTipoNombre) {
            switch (question.preguntaTipoNombre) {
                case PreguntaTipo.Coordenadas:
                    iconLabel = 'fa-solid fa-location-dot';
                    break;
                case PreguntaTipo.Fecha:
                    iconLabel = 'fa-solid fa-calendar-days';
                    break;
                case PreguntaTipo.FechaHora:
                    iconLabel = 'fa-regular fa-hourglass-half';
                    break;
                case PreguntaTipo.Hora:
                    iconLabel = 'fa-solid fa-clock';
                    break;
                case PreguntaTipo.Imagen:
                    iconLabel = 'fa-solid fa-camera'
                    break;
                case PreguntaTipo.Numerico:
                    iconLabel = 'fa-solid fa-arrow-up-9-1';
                    break;
                case PreguntaTipo.Seleccion:
                    iconLabel = 'fa-regular fa-circle';
                    break;
                case PreguntaTipo.SeleccionMultiple:
                    iconLabel = 'fa-solid fa-square-check';
                    break;
                case PreguntaTipo.Texto:
                    iconLabel = 'fa-solid fa-text-height';
                    break;
                case PreguntaTipo.CamaraGaleria:
                    iconLabel = 'fa-solid fa-mobile-screen';
                    break;
                case PreguntaTipo.Galeria:
                    iconLabel = 'fa-solid fa-image'
                    break;
                case PreguntaTipo.Archivo:
                    iconLabel = 'fa-solid fa-image'
                    break;
                    case PreguntaTipo.FechaRango:
                    iconLabel = 'fa-solid fa-calendar-days';
                    break;
                case PreguntaTipo.FechaRangoMultiple:
                    iconLabel = 'fa-solid fa-calendar-days';
                    break;
            }
        }

        return iconLabel;
    }
    // Handles

    const resetOnTypeChange = (type: PreguntaTipo) => {
        const internal = questionList[index];

        if (internal.preguntaTipoNombre === PreguntaTipo.Seleccion) {
            internal.respuestaOpcion = [{
                respuestaOpcionID: 0,
                preguntaID: 0,
                preguntaSiguienteID: 0,
                respuesta: null,
                resultado: null,
                orden: 0
            }]
        }

        if (type === PreguntaTipo.Seleccion) {
            internal.respuestaOpcion[0].resultado = null;
        }

        internal.valorMinimo = null;
        internal.valorMaximo = null;
        internal.frecuenciaActualizacionID = null;
        internal.query = null;
        return internal;
    }

    const handleTypeQuestion = (value: any) => {
        const valueParsed = JSON.parse(value);
        const internal = resetOnTypeChange(valueParsed.label);


        internal.preguntaTipo = valueParsed.val;
        internal.preguntaTipoNombre = valueParsed.label;

        if (valueParsed.label === PreguntaTipo.Seleccion && formQuestion?.esFormularioSecuencial) {
            question.esObligatoria = true;
        }

        const internalList = questionList;
        internalList[index] = internal;

        onChange([...questionList]);
    }

    const handleGroup = (value: any) => {
        const internalList = questionList;
        const valueParsed = JSON.parse(value);

        internalList[index].grupoPreguntaID = valueParsed?.grupoPreguntaID || null;
        internalList[index].formularioGrupoPreguntaID = valueParsed?.formularioGrupoPreguntaID || null;

        onChange([...internalList]);
    }

    // Question Options
    const handleOption = (value: any, indexOption: number) => {
        const internalList = questionList;
        internalList[index].respuestaOpcion[indexOption].respuesta = value;
        onChange([...internalList]);
    }

    const handleOptionOrden = (value: any, indexOption: number) => {
        const internalList = questionList;
        internalList[index].respuestaOpcion[indexOption].orden = parseInt(value);
        onChange([...internalList]);
    }

    const removeOption = (indexOption: number) => {
        const internalList = questionList;
        internalList[index].respuestaOpcion.splice(indexOption, 1);
        onChange([...internalList]);
    }

    const handleAddOption = () => {
        const internalList = questionList;
        internalList[index].respuestaOpcion.push({
            respuestaOpcionID: 0,
            preguntaID: 0,
            preguntaSiguienteID: 0,
            respuesta: '',
            resultado: null,
            orden: 0
        });
        onChange([...internalList]);
    }

    const handleOptionResultIndex = (value: string, indexOption: number) => {
        const internalList = questionList;
        internalList[index].respuestaOpcion[indexOption].resultado = value;
        onChange([...internalList]);
    }
    //

    const handleDuplicate = () => {
        const item = getCopyOf(questionList[index]) as IFormQuestion;
        item.preguntaID = 0;
        for (let i = 0; i < item.respuestaOpcion.length; i++) {
            item.respuestaOpcion[i].preguntaID = 0
            item.respuestaOpcion[i].respuestaOpcionID = 0
            item.respuestaOpcion[i].preguntaSiguienteID = null
          }
        onChange([...questionList, item]);
    }

    const handleRequired = (required: boolean) => {
        const internalList = questionList;
        internalList[index]['esObligatoria'] = required;
        onChange([...internalList]);
    }

    const handleAttrVal = (value: string, number: '1' | '2' | '3', type: 'attr' | 'val') => {
        const internalList = questionList;
        const prop = type === 'attr' ? 'atributoNombre' : 'atributoValor';

        internalList[index][`${prop}${number}`] = value;
        onChange([...internalList]);
    }

    const handleResult = (value: string) => {
        const internalList = questionList;
        if (question.preguntaTipoNombre !== PreguntaTipo.Seleccion) {
            internalList[index].respuestaOpcion[0].resultado = value;
        }
        onChange([...internalList]);
    }

    const handleOrder = (order: string) => {
        const internalList = questionList;
        internalList[index]['orden'] = parseInt(order);
        onChange([...internalList]);
    }

    const handleDelete = () => {
        const internalList = questionList;
        internalList.splice(index, 1);
        onChange([...internalList]);
    }

    const handleTitle = (value: string) => {
        const internalList = questionList;
        internalList[index]['pregunta'] = value;
        onChange([...internalList]);
    }

    const handleMinMax = (value: string, type: 'valorMinimo' | 'valorMaximo') => {
        const internalList = questionList;
        internalList[index][type] = value;
        onChange([...internalList]);
    }

    const handleQuery = (value: string) => {
        const internalList = questionList;
        internalList[index].query = value;
        onChange([...internalList]);
    }

    const handleFrecuenciaActualizacion = (value: string) => {
        const internalList = questionList;
        internalList[index].frecuenciaActualizacionID = parseInt(value);
        onChange([...internalList]);
    }

    const handleExecuteQuery = () => {
        tryCatch(() => {
            if (!!question.query) {
                setLoadingQuery(true);
                GetOptionsQuestionByQuery(question.query!)
                    .then((response) => {
                        const listOptions: IFormQuestionOption[] = response.data;
                        listOptions.forEach(option => {
                            option.preguntaID = question.preguntaID;
                            option.respuestaOpcionID = question.respuestaOpcion.find(x => x.respuesta === option.respuesta)?.respuestaOpcionID || 0;
                        });

                        question.respuestaOpcion = listOptions;
                        openNotification('success', 'Query exitoso', response.msg);
                        setModalQueryVisible(false);
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setLoadingQuery(false));
            }
        })
    }

    const getBackgroundValidation = () => {
        let background = COLORS.white_color2(1);

        if (questionHasError(question)) {
            background = '#FFFAFA';
        }

        return background;
    }

    const identifyError = (): string => {
        let error = '';

        switch (question.preguntaTipoNombre) {
            case PreguntaTipo.Numerico:
                if (!!question.valorMaximo && !!question.valorMinimo && parseFloat(question.valorMaximo) < parseFloat(question.valorMinimo)) {
                    error = "El valor (maximo) debe ser mayor al (mínimo)";
                }
                break;
            case PreguntaTipo.FechaHora:
            case PreguntaTipo.Fecha:
            case PreguntaTipo.FechaRango:
            case PreguntaTipo.FechaRangoMultiple:
                if (!!question.valorMaximo && !!question.valorMinimo && new Date(question.valorMaximo).getTime() < new Date(question.valorMinimo).getTime()) {
                    error = "La fecha y hora (hasta) debe ser mayor a la (desde)";
                }
                break;
            case PreguntaTipo.Hora:
                if (!!question.valorMaximo && !!question.valorMinimo && new Date(`${new Date().toDateString()} ${question.valorMaximo}`).getTime() < new Date(`${new Date().toDateString()} ${question.valorMinimo}`).getTime()) {
                    error = "El tiempo (hasta) debe ser mayor al (desde)";
                }
                break;
        }

        return error;
    }

    useEffect(() => {
        if (question.preguntaTipoNombre === PreguntaTipo.Seleccion && formQuestion?.esFormularioSecuencial) {
            question.esObligatoria = true;
        }
    }, []);

    return (
        <Wrapper style={{ backgroundColor: getBackgroundValidation() }}>

            {/* Input Header */}
            <GroupRow>
                <MarginInput width="60%">
                    <EditTextForm
                        value={question.pregunta}
                        onChange={handleTitle}
                        backgroundcolor={COLORS.white_color1}
                        name={"titulo"}
                        placeholder={"Titulo"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        inForm={false}
                        type={'text'}
                    />
                </MarginInput>
                <MarginInput width="35%">
                    <SelectBox
                        value={!!question.preguntaTipo ? JSON.stringify({ val: question.preguntaTipo, label: question.preguntaTipoNombre }) : null}
                        defaultValue={!!question.preguntaTipo ? JSON.stringify({ val: question.preguntaTipo, label: question.preguntaTipoNombre }) : null}
                        onChange={handleTypeQuestion}
                        icon={getIcon()}
                        placeholder={"Tipo"}
                        disabled={false}
                        allowClear={false}
                        loading={false}
                        options={typesQuestion.map(tq => ({ key: tq.value, value: JSON.stringify({ val: tq.key, label: tq.value }), text: tq.value }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.blue_main(1)}
                        textColor={COLORS.black_text_color1}
                    />
                </MarginInput>
            </GroupRow>

            {/* Ranges */}
            {showRange ? question.preguntaTipoNombre === PreguntaTipo.Numerico ||
                question.preguntaTipoNombre === PreguntaTipo.Fecha ||
                question.preguntaTipoNombre === PreguntaTipo.FechaHora ||
                question.preguntaTipoNombre === PreguntaTipo.Hora ||
                question.preguntaTipoNombre === PreguntaTipo.FechaRango ||
                question.preguntaTipoNombre === PreguntaTipo.FechaRangoMultiple ?

                <GroupRow style={{ marginTop: '18px' }}>
                    <MarginInput width="45%" style={{ marginBottom: '0px' }}>
                        <GroupColumn width="100%" style={{ marginBottom: '0px' }}>
                            <label>{returnRangeLabel('min')}:</label>
                            <EditTextForm
                                value={question.valorMinimo || ''}
                                onChange={(value: string) => handleMinMax(value, 'valorMinimo')}
                                backgroundcolor={COLORS.white_color1}
                                name={"minimo"}
                                placeholder={returnRangeLabel('min')}
                                borderColor={COLORS.black_text_color3}
                                textColor={COLORS.black_text_color1}
                                active={true}
                                decimalOrInteger={'decimal'}
                                inForm={false}
                                type={returnTypeRange()}
                            />
                        </GroupColumn>
                        <p className="error-text"></p>
                    </MarginInput>

                    <MarginInput width="45%" style={{ marginBottom: '0px' }}>
                        <GroupColumn width="100%" style={{ marginBottom: '0px' }}>
                            <label>{returnRangeLabel('max')}:</label>
                            <EditTextForm
                                value={question.valorMaximo || ''}
                                onChange={(value: string) => handleMinMax(value, 'valorMaximo')}
                                backgroundcolor={COLORS.white_color1}
                                name={"maximo"}
                                placeholder={returnRangeLabel('max')}
                                borderColor={COLORS.black_text_color3}
                                textColor={COLORS.black_text_color1}
                                active={true}
                                decimalOrInteger={'decimal'}
                                inForm={false}
                                type={returnTypeRange()}
                            />
                        </GroupColumn>
                        <p className="error-text">{identifyError()}</p>
                    </MarginInput>
                </GroupRow>
                :
                <></>
                : <></>
            }

            {/* Radio Options */}
            {question.preguntaTipoNombre === PreguntaTipo.Seleccion || question.preguntaTipoNombre === PreguntaTipo.SeleccionMultiple
                ?
                <div className="optionContainer">
                    <div className="scrollOption">
                        {question.respuestaOpcion.map((rp, optionIndex) =>
                            <div className="radioOption" key={optionIndex + "radioOption"}>
                                <GroupColumn>
                                    {question.preguntaTipoNombre === PreguntaTipo.Seleccion
                                        ? <i className="icon-radio"></i>
                                        : <i className="icon-check"></i>
                                    }
                                    <EditTextForm
                                        value={rp.respuesta!}
                                        onChange={(value: string) => handleOption(value, optionIndex)}
                                        backgroundcolor={COLORS.white_color2(1)}
                                        name={`radio${optionIndex + 1}`}
                                        placeholder={`Opción ${optionIndex + 1}`}
                                        borderColor={COLORS.blue_main(1)}
                                        textColor={COLORS.black_text_color1}
                                        active={true}
                                        inForm={false}
                                        type={'text'}
                                    />
                                    <div className="selectOrden">
                                        <SelectBox
                                            value={rp.orden}
                                            defaultValue={rp.orden}
                                            onChange={(value: string) => handleOptionOrden(value, optionIndex)}
                                            placeholder={"Orden"}
                                            height={'23px'}
                                            disabled={false}
                                            allowClear={false}
                                            loading={false}
                                            options={returnOrdenSelection(rp.orden.toString(), question.respuestaOpcion)}
                                            backgroundColor={COLORS.blue_inactive(1)}
                                            borderColor={COLORS.blue_main(1)}
                                            textColor={COLORS.blue_main(1)}
                                        />
                                    </div>
                                    <div className="selectOrden">
                                    <EditTextForm
                                        value={rp.resultado!}
                                        onChange={(value: string) => handleOptionResultIndex(value, optionIndex)}
                                        backgroundcolor={COLORS.white_color2(1)}
                                        name={`text${optionIndex + 1}`}
                                        placeholder={`Valor ${optionIndex + 1}`}
                                        borderColor={COLORS.black_text_color3}
                                        textColor={COLORS.black_text_color1}
                                        active={true}
                                        inForm={false}
                                        type={'text'}
                                    />
                                    </div>                                    
                                    <i className="fa-solid fa-xmark icon-effect" onClick={() => removeOption(optionIndex)}></i>
                                </GroupColumn>

                            </div>
                        )}
                    </div>
                    <FloatingBottom
                        icon={"+"}
                        method={handleAddOption}
                        iconSize={"1.5em"}
                        backgroundColor={COLORS.blue_inactive(1)}
                        color={COLORS.blue_main(1)}
                        size={"30px"}
                        style={{ position: 'absolute', right: '-50px', bottom: '0px' }}
                    />
                </div>
                :
                <></>
            }

            {/* Action Footer */}
            <div className="footer">
                <div className="textContainer">
                    {
                        [
                            PreguntaTipo.Fecha,
                            PreguntaTipo.FechaHora,
                            PreguntaTipo.Hora,
                            PreguntaTipo.Numerico,
                            PreguntaTipo.FechaRango,
                            PreguntaTipo.FechaRangoMultiple
                        ].map(x => x.toString()).includes(question?.preguntaTipoNombre!)
                        &&
                        <label className="textButton" onClick={() => showRemoveRange()}>
                            {(!showRange ? 'Añadir' : 'Remover') + ' rangos'}
                        </label>
                    }


                    {
                        [
                            PreguntaTipo.Seleccion,
                            PreguntaTipo.SeleccionMultiple,
                        ].map(x => x.toString()).includes(question?.preguntaTipoNombre!)
                        && <label className="textButton" onClick={() => setModalQueryVisible(true)}> Query</label>
                    }
                </div>

                <nav className="actions" onClick={handleDuplicate}>
                    <i className="fa-solid fa-clone"></i>
                </nav>
                <nav className="actions" onClick={handleDelete}>
                    <i className="fa-solid fa-trash-can"></i>
                </nav>

                <hr style={{ height: 25 }} className="separator" />

                <nav className="required">
                    <label>Obligatoria</label>
                    <Switch checked={question.esObligatoria} disabled={question.preguntaTipoNombre === PreguntaTipo.Seleccion && formQuestion?.esFormularioSecuencial} size={'small'} style={{ backgroundColor: COLORS.blue_main(1) }} onChange={handleRequired} />
                </nav>

                {formQuestion?.esFormularioSecuencial ||
                    <SelectBox
                        value={question.orden}
                        defaultValue={question.orden}
                        onChange={handleOrder}
                        placeholder={"Orden"}
                        height={'23px'}
                        disabled={false}
                        allowClear={false}
                        loading={false}
                        options={returnOrdenSelection(question.orden.toString(), questionList)}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.blue_main(1)}
                        textColor={COLORS.blue_main(1)}
                    />
                }

                <nav className="actions" onClick={() => setModalAttrVisible(true)}>
                    <i className="fa-solid fa-ellipsis-vertical"></i>
                </nav>

            </div>

            {/* Query Action */}
            <Modal props={{ style: { top: '-45px' } }} width={"50%"} title={'Opciones adicionales'} visible={modalQueryVisible} setVisible={setModalQueryVisible} askBeforeClose={false}>
                <GroupColumn>
                    <label>Query:</label>
                    <EditTextForm
                        value={question.query || ''}
                        onChange={handleQuery}
                        backgroundcolor={COLORS.white_color1}
                        name={"query"}
                        placeholder={"Query"}
                        borderColor={!!question.frecuenciaActualizacionID && !question.query ? COLORS.red_error1 : COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={!loadingQuery}
                        inForm={false}
                        type={'textarea'}
                    />
                </GroupColumn>

                <GroupColumn>
                    <label>Frecuencia de actualización:</label>
                    <SelectBox
                        value={question.frecuenciaActualizacionID}
                        defaultValue={question.frecuenciaActualizacionID}
                        onChange={handleFrecuenciaActualizacion}
                        placeholder={"Frecuencia de actualización"}
                        disabled={loadingQuery}
                        allowClear={true}
                        loading={loadingListFrecuency}
                        options={listFrecuency.map(frec => ({ key: frec.nombre, value: frec.frecuenciaActualizacionID.toString(), text: frec.nombre }))}
                        backgroundColor={COLORS.white_color1}
                        borderColor={!question.frecuenciaActualizacionID && !!question.query ? COLORS.red_error1 : COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                </GroupColumn>

                <LoadingButton
                    type="button"
                    method={handleExecuteQuery}
                    title={"Ejecutar"}
                    loading={loadingQuery.toString()}
                    background={COLORS.blue_active}
                    color={COLORS.white_color1}
                    style={{ padding: '3px', width: '200px', float: 'right', height: '32px', marginRight: 30 }}
                    fontsize={16}
                />
            </Modal>

            {/* More Action */}
            <Modal props={{ style: { top: '-45px' } }} width={"50%"} title={'Atributos adicionales'} visible={modalAttrVisible} setVisible={setModalAttrVisible} askBeforeClose={false}>
                {question.preguntaTipoNombre !== PreguntaTipo.SeleccionMultiple && question.preguntaTipoNombre !== PreguntaTipo.Seleccion &&
                    <GroupColumn>
                        <label>Valor:</label>
                        <EditTextForm
                            value={questionList[index].respuestaOpcion[0]?.resultado || ''}
                            onChange={handleResult}
                            backgroundcolor={COLORS.white_color1}
                            name={"Valor"}
                            placeholder={"Valor"}
                            borderColor={COLORS.black_text_color3}
                            textColor={COLORS.black_text_color1}
                            active={true}
                            inForm={false}
                            type={'text'}
                        />
                    </GroupColumn>
                }

                <GroupColumn style={{ marginBottom: '15px' }}>
                    <label>Grupo:</label>
                    <SelectBox
                        value={question.grupoPreguntaID ? JSON.stringify({ grupoPreguntaID: question.grupoPreguntaID, formularioGrupoPreguntaID: question.formularioGrupoPreguntaID }) : null}
                        defaultValue={question.grupoPreguntaID ? JSON.stringify({ grupoPreguntaID: question.grupoPreguntaID, formularioGrupoPreguntaID: question.formularioGrupoPreguntaID }) : null}
                        onChange={handleGroup}
                        placeholder={"Grupo"}
                        disabled={false}
                        allowClear={true}
                        loading={false}
                        options={formQuestion?.formularioGrupoPregunta?.map(group => ({ key: group.grupoPreguntaNombre, value: JSON.stringify({ grupoPreguntaID: group.grupoPreguntaID || null, formularioGrupoPreguntaID: group.formularioGrupoPreguntaID || null }), text: group.grupoPreguntaNombre })) || []}
                        backgroundColor={COLORS.white_color1}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                </GroupColumn>

                <hr style={{ borderTop: `0px solid ${COLORS.black_text_color3}`, position: 'absolute', right: 0, left: 0 }} />

                <GroupRow style={{ marginTop: '30px' }}>
                    <GroupColumn width="45%">
                        <label>Atributo 1:</label>
                        <EditTextForm
                            value={question.atributoNombre1 || ''}
                            onChange={(val: string) => handleAttrVal(val, '1', 'attr')}
                            backgroundcolor={COLORS.white_color1}
                            name={"atributo1"}
                            placeholder={"Atributo 1"}
                            borderColor={firstHasValueIfSecondHas(question.atributoNombre1, question.atributoValor1) ? COLORS.black_text_color3 : COLORS.red_error1}
                            textColor={COLORS.black_text_color1}
                            active={true}
                            inForm={false}
                            type={'text'}
                        />
                    </GroupColumn>
                    <GroupColumn width="45%">
                        <label>Valor 1:</label>
                        <EditTextForm
                            value={question.atributoValor1 || ''}
                            onChange={(val: string) => handleAttrVal(val, '1', 'val')}
                            backgroundcolor={COLORS.white_color1}
                            name={"valor1"}
                            placeholder={"Valor 1"}
                            borderColor={firstHasValueIfSecondHas(question.atributoValor1, question.atributoNombre1) ? COLORS.black_text_color3 : COLORS.red_error1}
                            textColor={COLORS.black_text_color1}
                            active={true}
                            inForm={false}
                            type={'text'}
                        />
                    </GroupColumn>
                </GroupRow>

                <GroupRow style={{ marginTop: '5px' }}>
                    <GroupColumn width="45%">
                        <label>Atributo 2:</label>
                        <EditTextForm
                            value={question.atributoNombre2 || ''}
                            onChange={(val: string) => handleAttrVal(val, '2', 'attr')}
                            backgroundcolor={COLORS.white_color1}
                            name={"atributo2"}
                            placeholder={"Atributo 2"}
                            borderColor={firstHasValueIfSecondHas(question.atributoNombre2, question.atributoValor2) ? COLORS.black_text_color3 : COLORS.red_error1}
                            textColor={COLORS.black_text_color1}
                            active={true}
                            inForm={false}
                            type={'text'}
                        />
                    </GroupColumn>
                    <GroupColumn width="45%">
                        <label>Valor 2:</label>
                        <EditTextForm
                            value={question.atributoValor2 || ''}
                            onChange={(val: string) => handleAttrVal(val, '2', 'val')}
                            backgroundcolor={COLORS.white_color1}
                            name={"valor2"}
                            placeholder={"Valor 2"}
                            borderColor={firstHasValueIfSecondHas(question.atributoValor2, question.atributoNombre2) ? COLORS.black_text_color3 : COLORS.red_error1}
                            textColor={COLORS.black_text_color1}
                            active={true}
                            inForm={false}
                            type={'text'}
                        />
                    </GroupColumn>
                </GroupRow>
                <GroupRow style={{ marginTop: '5px' }}>
                    <GroupColumn width="45%">
                        <label>Atributo 3:</label>
                        <EditTextForm
                            value={question.atributoNombre3 || ''}
                            onChange={(val: string) => handleAttrVal(val, '3', 'attr')}
                            backgroundcolor={COLORS.white_color1}
                            name={"atributo3"}
                            placeholder={"Atributo 3"}
                            borderColor={firstHasValueIfSecondHas(question.atributoNombre3, question.atributoValor3) ? COLORS.black_text_color3 : COLORS.red_error1}
                            textColor={COLORS.black_text_color1}
                            active={true}
                            inForm={false}
                            type={'text'}
                        />
                    </GroupColumn>
                    <GroupColumn width="45%">
                        <label>Valor 3:</label>
                        <EditTextForm
                            value={question.atributoValor3 || ''}
                            onChange={(val: string) => handleAttrVal(val, '3', 'val')}
                            backgroundcolor={COLORS.white_color1}
                            name={"valor3"}
                            placeholder={"Valor 3"}
                            borderColor={firstHasValueIfSecondHas(question.atributoValor3, question.atributoNombre3) ? COLORS.black_text_color3 : COLORS.red_error1}
                            textColor={COLORS.black_text_color1}
                            active={true}
                            inForm={false}
                            type={'text'}
                        />
                    </GroupColumn>
                </GroupRow>
            </Modal>
        </Wrapper>
    );
}


export default TypeQuestionModel;